module.exports = __webpack_public_path__ + "img/form1.15471c3d.png";